import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import useClasses from '../../../hooks/useClasses';

import './style.scss';
import useRoutes from '../../../hooks/useRoutes';
import { ROUTE_TYPE_GUIDED_SELF_HELP } from '../../../config/constants';

interface Props {
  pairingCode: string
}

const BlockParingCode: React.FC<Props> = ({
  pairingCode,
}) => {
  const { buildClass } = useClasses('BlockParingCode');
  const { t } = useTranslation();
  const { inviteClient } = useRoutes(ROUTE_TYPE_GUIDED_SELF_HELP);

  return (
    <div className={buildClass()}>
      <h2 className={buildClass('heading')}>
        {t('your_pairing_code.title')}
      </h2>
      <div className={buildClass('body')}>
        <div className={buildClass('pairing-code')}>
          <strong>{pairingCode}</strong>
        </div>
        <p className={buildClass('description')}>
          {t('your_pairing_code.description')}
        </p>
      </div>
      <Button href={inviteClient} secondary className={buildClass('cta-button')}>
        {t('your_pairing_code.cta')}
      </Button>
    </div>
  );
};

export default BlockParingCode;
